import { putCookie } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getPublicToken } from '../../services/auth'

export const GET_PUBLIC_TOKEN = 'GET_PUBLIC_TOKEN'
export const GET_PUBLIC_TOKEN_ERROR = 'GET_PUBLIC_TOKEN_ERROR'
export const GET_PUBLIC_TOKEN_SUCCESS = 'GET_PUBLIC_TOKEN_SUCCESS'
export const onGetPublicToken = makeActionCreator(GET_PUBLIC_TOKEN)
export const onGetPublicTokenError = makeActionCreator(GET_PUBLIC_TOKEN_ERROR, 'payload')
export const onGetPublicTokenSuccess = makeActionCreator(GET_PUBLIC_TOKEN_SUCCESS, 'payload')
export const onGetPublicTokenThunk = () => async dispatch => {
  dispatch(onGetPublicToken())

  try {
    const { data } = await getPublicToken()

    putCookie('access_token', data.payload?.access_token)

    return dispatch(onGetPublicTokenSuccess())
  } catch (error) {
    return dispatch(
      onGetPublicTokenError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}
